<template>
    <component :is="getIconComponent(name)" />
</template>
<script>
import IconLogin from '@/components/icons/icon-login.vue';
import IconAlert from '@/components/icons/icon-alert.vue';
import IconAlert2 from '@/components/icons/icon-alert-2.vue';
import IconUser from '@/components/icons/icon-user.vue';
import IconUser2 from '@/components/icons/icon-user-2.vue';
import IconArrowDownload from '@/components/icons/icon-arrow-download.vue';
import IconArrowBottom from '@/components/icons/icon-arrow-bottom.vue';
import IconArrowLeft from '@/components/icons/icon-arrow-left.vue';
import IconArrowRight from '@/components/icons/icon-arrow-right.vue';
import IconArrowRight2 from '@/components/icons/icon-arrow-right-2.vue';
import IconArrowTable from '@/components/icons/icon-arrow-table.vue';
import IconCalendar from '@/components/icons/icon-calendar.vue';
import IconCamera from '@/components/icons/icon-camera.vue';
import IconCampaign from '@/components/icons/icon-campaign.vue';
import IconCertificate from '@/components/icons/icon-certificate.vue';
import IconChat from '@/components/icons/icon-chat.vue';
import IconCheck from '@/components/icons/icon-check.vue';
import IconCheckBox from '@/components/icons/icon-check-box.vue';
import IconCircleArrowLeft from '@/components/icons/icon-circle-arrow-left.vue';
import IconCircleArrowRight from '@/components/icons/icon-circle-arrow-right.vue';
import IconClose from '@/components/icons/icon-close.vue';
import IconClose2 from '@/components/icons/icon-close-2.vue';
import IconCloudFile from '@/components/icons/icon-cloud-file.vue';
import IconCloudFile2 from '@/components/icons/icon-cloud-file-2.vue';
import IconCommentQuestion from '@/components/icons/icon-comment-question.vue';
import IconComments from '@/components/icons/icon-comments.vue';
import IconCommunication from '@/components/icons/icon-communication.vue';
import IconCourse from '@/components/icons/icon-course.vue';
import IconDashboard from '@/components/icons/icon-dashboard.vue';
import IconEditPencil from '@/components/icons/icon-edit-pencil.vue';
import IconFileCircle from '@/components/icons/icon-file-circle.vue';
import IconFile from '@/components/icons/icon-file.vue';
import IconFolder from '@/components/icons/icon-folder.vue';
import IconGetOut from '@/components/icons/icon-get-out.vue';
import IconGraduation from '@/components/icons/icon-graduation.vue';
import IconGroup from '@/components/icons/icon-group.vue';
import IconInfo from '@/components/icons/icon-info.vue';
import IconLabel from '@/components/icons/icon-label.vue';
import IconLocation from '@/components/icons/icon-location.vue';
import IconMsg from '@/components/icons/icon-msg.vue';
import IconMsgBorder from '@/components/icons/icon-msg-border.vue';
import IconMusic from '@/components/icons/icon-music.vue';
import IconOptions from '@/components/icons/icon-options.vue';
import IconPencil from '@/components/icons/icon-pencil.vue';
import IconPhone from '@/components/icons/icon-phone.vue';
import IconResultNote from '@/components/icons/icon-result-note.vue';
import IconRevision from '@/components/icons/icon-revision.vue';
import IconSearch from '@/components/icons/icon-search.vue';
import IconSend from '@/components/icons/icon-send.vue';
import IconStar from '@/components/icons/icon-star.vue';
import IconStar2 from '@/components/icons/icon-star-2.vue';
import IconStatisticalResult from '@/components/icons/icon-statistical-result.vue';
import IconTableCreate from '@/components/icons/icon-table-create.vue';
import IconTime from '@/components/icons/icon-time.vue';
import IconTrash from '@/components/icons/icon-trash.vue';
import IconTrendingUp from '@/components/icons/icon-trending-up.vue';
import IconCart from '@/components/icons/icon-cart.vue';
import IconUndo from '@/components/icons/icon-undo.vue';
import IconValidDoc from '@/components/icons/icon-valid-doc.vue';
import IconVideo from '@/components/icons/icon-video.vue';
import IconWallet from '@/components/icons/icon-wallet.vue';
import IconWatch from '@/components/icons/icon-watch.vue';
import IconWhatsapp from '@/components/icons/icon-whatsapp.vue';
import IconWorld from '@/components/icons/icon-world.vue';
import IconYoutube from '@/components/icons/icon-youtube.vue';
import IconHelp from '@/components/icons/icon-help.vue';
import IconPlus from '@/components/icons/icon-plus.vue';
import IconTableCreateBlue from '@/components/icons/icon-table-create-blue.vue';
import IconCollapseResponsive from '@/components/icons/icon-collapse-responsive.vue'
import IconCircleCheck from '@/components/icons/icon-circle-check.vue'

const ICONS_COMPONENTS = {
    'login': IconLogin,
    'alert': IconAlert,
    'alert-2': IconAlert2,
    'user': IconUser,
    'user-2': IconUser2,
    'arrow-download': IconArrowDownload,
    'arrow-bottom': IconArrowBottom,
    'arrow-left': IconArrowLeft,
    'arrow-right': IconArrowRight,
    'arrow-right-2': IconArrowRight2,
    'arrow-table': IconArrowTable,
    'calendar': IconCalendar,
    'camera': IconCamera,
    'campaign': IconCampaign,
    'certificate': IconCertificate,
    'chat': IconChat,
    'check': IconCheck,
    'check-box': IconCheckBox,
    'circle-arrow-left': IconCircleArrowLeft,
    'circle-arrow-right': IconCircleArrowRight,
    'close': IconClose,
    'close-2': IconClose2,
    'cloud-file': IconCloudFile,
    'cloud-file-2': IconCloudFile2,
    'comment-question': IconCommentQuestion,
    'comments': IconComments,
    'communication': IconCommunication,
    'course': IconCourse,
    'dashboard': IconDashboard,
    'edit-pencil': IconEditPencil,
    'file-circle': IconFileCircle,
    'file': IconFile,
    'folder': IconFolder,
    'get-out': IconGetOut,
    'graduation': IconGraduation,
    'group': IconGroup,
    'info': IconInfo,
    'label': IconLabel,
    'location': IconLocation,
    'msg': IconMsg,
    'msg-border': IconMsgBorder,
    'music': IconMusic,
    'options': IconOptions,
    'pencil': IconPencil,
    'phone': IconPhone,
    'result-note': IconResultNote,
    'revision': IconRevision,
    'search': IconSearch,
    'send': IconSend,
    'star': IconStar,
    'star-2': IconStar2,
    'statistical-result': IconStatisticalResult,
    'table-create': IconTableCreate,
    'time': IconTime,
    'trash': IconTrash,
    'trending-up': IconTrendingUp,
    'cart': IconCart,
    'undo': IconUndo,
    'valid-doc': IconValidDoc,
    'video': IconVideo,
    'wallet': IconWallet,
    'watch': IconWatch,
    'whatsapp': IconWhatsapp,
    'world': IconWorld,
    'youtube': IconYoutube,
    'help': IconHelp,
    'plus': IconPlus,
    'burger-responsive':IconCollapseResponsive,
    'table-create-blue':IconTableCreateBlue,
    'circle-check': IconCircleCheck
}
export default {
    components: {
        IconLogin
    },
    props: {
        name: {
            type: String,
            default: 'invalid'
        },
    },
    mounted(){
        this.$emit('iconsComponent',ICONS_COMPONENTS)
    },
    methods: {
        getIconComponent(name) {
            return ICONS_COMPONENTS[name] || IconLogin
        }
    }
}
</script>